import type { Listeners } from '../helpers';
import { controllerHelpers } from '../helpers';
import type { OrderSummaryManager, PromoCodesManager } from '../managers';
import { inboundPromoCodesEventBus } from '../managers';

/**
 * Controller used for direct application of promo codes.
 *
 * Listens for inbound promo codes (from partner IDs) and applies them via PromoCodesManager.
 * Used on BuyNow only — on Payflow, codes travel via URL redirect between steps.
 */
export class InboundPromoCodeApplicationController {
  public listeners: Listeners;

  constructor(private orderSummaryManager: OrderSummaryManager, private promoCodesManager: PromoCodesManager) {
    this.listeners = controllerHelpers.createListeners([
      inboundPromoCodesEventBus.bindTo('inboundPromoCodesReceived', this.onInboundPromoCodesReceived),
    ]);
  }

  private onInboundPromoCodesReceived = async (codes: string[]) => {
    await this.orderSummaryManager.getApiWhenReady();

    const api = await this.promoCodesManager.getApiWhenReady();

    await api.applyPromoCodes(codes);
  };
}
